import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0D0118] py-12 border-t border-white/10 px-4 sm:px-6 lg:px-8 text-center" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <h2 className="text-2xl font-black text-white mb-6" data-id="element-78">
          Expertas en{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF2D8A] to-[#FFD700] italic" data-id="element-79">
            BallCat
          </span>
        </h2>

        <p className="text-gray-500 text-sm mb-4" data-id="element-80">
          &copy; {currentYear} Expertas en BallCat. Todos los derechos
          reservados.
        </p>

        <p className="text-gray-600 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-81">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc. Los resultados
          pueden variar de persona a persona. La información contenida en este
          producto no sustituye el consejo médico o psicológico profesional.
        </p>
      </div>
    </footer>;
}